import React from 'react';
import ReportViewer from "./base/ReportViewer";

const StatistiquesDePrisesDePecheParTypeDeSejours = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"StatistiquesDePrisesDePecheParTypeDeSejours"}/>
        </div>
    );
}
export default StatistiquesDePrisesDePecheParTypeDeSejours;